var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.865,
    x2: 0.088,
    y2: 1.08,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fc4a4a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#792ffe"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1567 -221)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(1567 221)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.316,13.781l.73-.171Zm0-5.457.73.171Zm15.474,0,.73-.171Zm0,5.457-.73-.171h0Zm-5.008,5.008-.171-.73h0Zm-5.457,0-.171.73h0Zm0-15.474-.171-.73Zm5.457,0,.171-.73h0ZM20.47,21.53A.75.75,0,0,0,21.53,20.47ZM4.046,13.61a11.2,11.2,0,0,1,0-5.115l-1.46-.343a12.7,12.7,0,0,0,0,5.8ZM18.059,8.5a11.2,11.2,0,0,1,0,5.115l1.46.342a12.7,12.7,0,0,0,0-5.8ZM13.61,18.059a11.2,11.2,0,0,1-5.115,0l-.343,1.46a12.7,12.7,0,0,0,5.8,0ZM8.5,4.046a11.2,11.2,0,0,1,5.115,0l.342-1.46a12.7,12.7,0,0,0-5.8,0Zm0,14.013A5.971,5.971,0,0,1,4.046,13.61l-1.46.342A7.471,7.471,0,0,0,8.153,19.52Zm5.457,1.46a7.471,7.471,0,0,0,5.567-5.567l-1.46-.342a5.97,5.97,0,0,1-4.449,4.449ZM13.61,4.046A5.971,5.971,0,0,1,18.059,8.5l1.46-.343a7.471,7.471,0,0,0-5.567-5.567ZM8.153,2.586A7.471,7.471,0,0,0,2.586,8.153l1.46.343A5.971,5.971,0,0,1,8.5,4.046ZM16.8,17.865,20.47,21.53,21.53,20.47,17.865,16.8Z",
    transform: "translate(1578 232)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.f2ec39d0349c92109dc90dff630a19b1.svg";
export { ForwardRef as ReactComponent };